import PostQualificationNotFound from "./PostQualificationNotFound.vue";
export default PostQualificationNotFound;
